import { action, observable } from 'mobx';

export const SearchState = observable({
  isOpen: false,
});
export const openSearch = action(() => {
  SearchState.isOpen = true;
});
export const closeSearch = action(() => {
  SearchState.isOpen = false;
});
